var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<span ng-show=\"$ctrl.bus.activeCalls.length\"><i class=\"fa fa-spinner fa-2x fa-pulse text-warning\"></i> </span><a ng-if=\"!$ctrl.bus.activeCalls.length\" ng-click=\"$ctrl.prompt()\" href><b class=\"fa fa-lg fa-{{$ctrl.getIconClasses($ctrl.ngModel.status)}}\" style=\"width: 15px;\" uib-tooltip=\"{{$ctrl.ngModel.status}}\" tooltip-append-to-body=\"true\"></b></a>";
var id1="prospect-status.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;